import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import { db } from '../firebase/Firebase'
import ColType from '../Types'
//import { Layout, Icon, Button, Checkbox, Table } from 'antd'
import ChatHome from '../teacher/chat/ChatHome'
import { flattenDoc } from '../Util'

class InstructionalFacilitatorChatHome extends Component {
    state = {
        schoolPersonnelDict: {},
        retrievedTeachers: false,
    }

    componentDidMount() {
        this.getTeachers()
    }

    componentWillReceiveProps(nextProps) {
        this.getTeachers()
    }

    getTeachers = () => {
        if (!(this.props.instructionalFacilitatorBaseProps &&
            this.props.instructionalFacilitatorBaseProps.instructionalFacilitator &&
            this.props.instructionalFacilitatorBaseProps.schools)) {
            return
        }
        if (this.state.retrievedTeachers) {
            return
        }
        this.setState({ retrievedTeachers: true })

        // accumulate into a local — state is only written once, on full success
        const localDict = {}
        const promises = []

        this.props.instructionalFacilitatorBaseProps.schools.forEach((school) => {
            localDict[school.id] = {
                'school': school, 'teachers': [], 'instructionalFacilitators': [], 'schoolAdmins': []
            }

            promises.push(
                db.collection(ColType.teacher)
                    .where('schoolId', '==', school.id)
                    .where('districtId', '==', school.districtId)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            localDict[school.id]['teachers'].push(flattenDoc(doc))
                        })
                    })
            )

            promises.push(
                db.collection(ColType.instructionalFacilitator)
                    .where('schoolIds', 'array-contains', school.id)
                    .where('districtId', '==', school.districtId)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            localDict[school.id]['instructionalFacilitators'].push(flattenDoc(doc))
                        })
                    })
            )
        })

        Promise.all(promises)
            .then(() => {
                this.setState({
                    schoolPersonnelDict: localDict,
                    personnelLoaded: true,
                })
            })
            .catch(() => {

            })
    }

    render() {
        return (
            <div>
                <ChatHome
                    personRole={'instructionalFacilitator'}
                    person={this.props.instructionalFacilitatorBaseProps.instructionalFacilitator}
                    schoolPersonnelDict={this.state.schoolPersonnelDict}
                    students={[]}
                    IEPGoals={[]}
                    IEPDict={{}}
                    schoolId={''}
                    chatNotificationDict={this.props.instructionalFacilitatorBaseProps.chatNotificationDict}
                    setCurrentlyViewingChatIdFunc={this.props.instructionalFacilitatorBaseProps.setCurrentlyViewingChatIdFunc}
                />
            </div>
        )
    }
}

export default InstructionalFacilitatorChatHome
